import { memo, ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import TruncatedText from './TruncatedText'
import { formatDateWithUserPreferences } from '../../utils/DateAndTimeUtils'
import { IMRTColumn } from '../Entity/interfaces'
import {
    isBoolean,
    isDate,
    isDistance,
    isHumidity,
    isRuleSet,
    isTemperature,
    isWeight,
} from '../../utils/MiscellaneousUtils'
import { useAppSelector } from '../../redux/hook'

interface IValueDisplayBox {
    dataValue: any
    item: IMRTColumn
    fontSize?: string
    showUnits?: boolean
}

const shouldRoundOff = (item: IMRTColumn) => {
    if (
        isTemperature(item) ||
        isHumidity(item) ||
        isWeight(item) ||
        isDistance(item)
    ) {
        return true
    }
    return false
}

const EntityTableCell = ({
    dataValue,
    item,
    fontSize,
    showUnits = false, //we are use same for preview and list( for listing page no need to show units)
}: IValueDisplayBox): ReactElement => {
    const value = dataValue
    const userLocalization = useAppSelector(
        (state) => state.user.user?.preferences?.localization,
    )

    if (
        (value == null || value === undefined || value === '') &&
        !isBoolean(item)
    ) {
        return <Box sx={{ width: '100%' }} />
    }

    let formattedValue
    if (isDate(item)) {
        formattedValue = value
            ? formatDateWithUserPreferences(value, userLocalization)
            : ''
    } else if (isBoolean(item)) {
        formattedValue = value ? 'True' : 'False'
    } else if (isRuleSet(item)) {
        formattedValue = value?.map((i: any) => i.ruleSetName).join(', ')
    } else {
        formattedValue = Array.isArray(value) ? value.join(', ') : value
    }
    return (
        <Box sx={{ width: '100%' }}>
            {shouldRoundOff(item) ? (
                <Typography sx={fontSize ? { fontSize } : undefined}>
                    {formattedValue !== 0
                        ? `${Number(formattedValue).toFixed(1)}${item?.unit && showUnits ? ' ' + item?.unit : ''}`
                        : `${formattedValue}${item?.unit && showUnits ? ' ' + item?.unit : ''}`}
                </Typography>
            ) : (
                <TruncatedText
                    sx={fontSize ? { fontSize } : undefined}
                    text={`${formattedValue}${item?.unit && showUnits ? ' ' + item?.unit : ''}`}
                />
            )}
        </Box>
    )
}

const MemoizedEntityTableCell = memo(EntityTableCell)
MemoizedEntityTableCell.displayName = 'EntityTableCell'
export default MemoizedEntityTableCell
